// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowSequenceEditPage_root__1PqcD","title":"FlowSequenceEditPage_title__2WRh7","flowSequence":"FlowSequenceEditPage_flowSequence__jhzHW"};